var _style, _path, _path2, _path3, _path4, _path5, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBybit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 768 283",
    style: {
      enableBackground: "new 0 0 768 283"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F7A600;}\r\n\t.st1{fill:#ababab;}\r\n\t.st2{fill:none;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.4,207.9V19h38v188.9H542.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.8,264H18.4V75.1h78.1c38,0,60.1,20.7,60.1,53.1c0,21-14.2,34.5-24,39c11.7,5.3,26.8,17.2,26.8,42.5 C159.4,244.9,134.5,264,99.8,264z M93.6,108H56.5v43.5h37.1c16.1,0,25.1-8.8,25.1-21.8S109.7,108,93.6,108z M96,184.6H56.4V231H96 c17.2,0,25.4-10.6,25.4-23.4S113.2,184.6,96,184.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.2,186.5V264h-37.7v-77.5L179,75.1h41.2l36.3,76.1l35.8-76.1h41.2L275.2,186.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M441.3,264h-81.4V75.1H438c38,0,60.1,20.7,60.1,53.1c0,21-14.2,34.5-24,39c11.7,5.3,26.8,17.2,26.8,42.5 C500.8,244.9,476,264,441.3,264z M435,108h-37.1v43.5H435c16.1,0,25.1-8.8,25.1-21.8S451.1,108,435,108z M437.4,184.6h-39.6V231 h39.6c17.2,0,25.4-10.6,25.4-23.4S454.7,184.6,437.4,184.6L437.4,184.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M702.7,108v156h-38V108H614V75.1h139.5V108H702.7z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -6,
    y: -9.1,
    className: "st2",
    width: 784,
    height: 301.1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBybit);
export default __webpack_public_path__ + "static/media/bybit.fa1579d0e13faddc6f9c37702f654b81.svg";
export { ForwardRef as ReactComponent };